export default function Snackbar({ children, admin }: any) {
  return (
    <div className={!admin ? 'absolute w-[67%] md:w-[calc(80dvw)] h-44 md:h-[110px] top-[85%] right-[17%] md:right-[calc((100dvw-80dvw)/2)] bg-[#2F2F35] flex justify-center items-center text-13 md:text-32 leading-16 md:leading-40 font-preLight opacity-80 rounded-[5px] md:rounded-[12px] z-[1000] whitespace-pre-line'
      : 'absolute w-[67%] md:w-[calc(80dvw)] h-57 md:h-[142px] top-[70%] right-[17%] md:right-[calc((100dvw-80dvw)/2)] bg-[#2F2F35] flex justify-center items-center text-16 md:text-40 leading-16 md:leading-40 opacity-80 rounded-[5px] md:rounded-[12px] z-[1000] whitespace-pre-line'}>
      {children}
    </div>
  );
}